import React from 'react';
import { useTranslation } from 'react-i18next';
import InviteContactsForm from './InviteContactsForm';
/**
 * Component that represents the invitation section of the {@code AddPeopleDialog}.
 *
 * @returns {ReactElement$<any>}
 */
function InviteContactsSection() {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { style: { fontSize: "16px" } },
            t('addPeople.sipCode'),
            React.createElement("span", { style: { color: 'red' } }, "*")),
        React.createElement(InviteContactsForm, null)));
}
export default InviteContactsSection;
